import EzController from 'controllers/ez-base-controller';
import Cookies from 'js-cookie';

export default class AbDetectionController extends EzController {
  connect() {
    this.sendBeaconIfNecessary();
  }

  sendBeaconIfNecessary() {
    if (!window.aBDetected) return;
    if (Cookies.get('aBDetected')) return;

    Cookies.set('aBDetected', true);

    const formData = new FormData();
    formData.append(this.csrfParam, this.csrfToken);
    formData.append('eventAction', 'AdBlocker');
    formData.append('eventCategory', document.body.dataset.conversionsCategory);
    formData.append('nonInteractive', true);

    window.navigator.sendBeacon(this.trackingUrl, formData);
  }

  get trackingUrl() {
    return this.element.dataset.abDetectionUrl;
  }

  get csrfParam() {
    const csrfParamTag = document.querySelector('meta[name=csrf-param]');
    if (csrfParamTag) {
      return csrfParamTag.content;
    }

    return null;
  }

  get csrfToken() {
    const csrfTokenTag = document.querySelector('meta[name=csrf-token]');
    if (csrfTokenTag) {
      return csrfTokenTag.content;
    }

    return null;
  }
}
